import script from "./STK01_011INS_01.vue?vue&type=script&setup=true&lang=js"
export * from "./STK01_011INS_01.vue?vue&type=script&setup=true&lang=js"

import "./STK01_011INS_01.vue?vue&type=style&index=0&id=6a1881c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1881c8"]])

export default __exports__